import React from 'react';
import { Tag } from 'carbon-components-react';

export function CompletionStatusTag(props) {

  let completionStateToColorMap = {
    'not reviewed': 'green',
    'reviewed': 'red'
  };

  const value = props.value;
  if (!value) return null;

  return (
    <Tag
      type={completionStateToColorMap[value.toLowerCase()]}
      disabled={false} role="listitem"
    >
      {value}
    </Tag>
  );
}